"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread2"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/toConsumableArray"));

var _react = _interopRequireDefault(require("react"));

var _humps = _interopRequireDefault(require("humps"));

require("./StreamlineIcon.css");

var StreamlineIcon = function StreamlineIcon(props) {
  var icon = props.icon,
      fill = props.fill,
      size = props.size,
      stroke = props.stroke,
      width = props.width,
      height = props.height,
      customClassName = props.customClassName;

  var getClassName = function getClassName() {
    var className = ["Streamline_Icon"];
    if (props.spin) className.push('Streamline_Icon_Spin', 'Streamline_Icon_Animated');
    if (props.pulse) className.push('Streamline_Icon_Pulse', 'Streamline_Icon_Animated');
    if (props.infinite) className.push('Streamline_Animation_Infinite');
    if (props.fast) className.push('Streamline_Animation_Fast');
    if (props.easeInOut) className.push('Streamline_Animation_EaseInOut');
    if (customClassName) className.push(customClassName);
    return (0, _toConsumableArray2.default)(new Set(className)).join(' ');
  };

  var getSize = function getSize() {
    //Default
    var sizeObject = {
      width: icon[1],
      height: icon[2],
      isDefault: true
    };

    if (size) {
      sizeObject.isDefault = size === sizeObject.width;
      sizeObject.height = size;
      sizeObject.width = size;
    } else {
      if (height && parseInt(height) !== sizeObject.height) {
        sizeObject.height = height;
        sizeObject.isDefault = false;
      }

      if (width && parseInt(width) !== sizeObject.width) {
        sizeObject.width = width;
        sizeObject.isDefault = false;
      }
    }

    return sizeObject;
  };

  var getStyle = function getStyle() {
    var sizeObj = getSize();
    delete sizeObj.isDefault;
    return (0, _objectSpread2.default)({}, sizeObj);
  };

  var renderIcon = function renderIcon() {
    var size = getSize();

    var renderPaths = function renderPaths() {
      return icon[4].map(function (path, index) {
        var options = (0, _objectSpread2.default)({}, _humps.default.camelizeKeys(icon[3][index]));
        options['stroke'] = stroke || icon[3][index]['stroke'];
        options['fill'] = fill || icon[3][index]['fill'];
        return /*#__PURE__*/_react.default.createElement("path", Object.assign({}, options, {
          key: Math.random().toString(),
          d: path
        }));
      });
    };

    return /*#__PURE__*/_react.default.createElement("span", {
      className: getClassName()
    }, /*#__PURE__*/_react.default.createElement("svg", {
      viewBox: "0 0 ".concat(size.width, " ").concat(size.height),
      style: (0, _objectSpread2.default)({}, getStyle()),
      width: size.width,
      height: size.height
    }, !size.isDefault ? /*#__PURE__*/_react.default.createElement("g", {
      transform: "scale(".concat(size.width / icon[1], ",").concat(size.height / icon[2], ")")
    }, renderPaths()) : renderPaths()));
  };

  return renderIcon();
};

StreamlineIcon.defaultProps = {
  size: 24,
  pulse: false,
  spin: false,
  fast: false,
  easeInOut: false,
  infinite: false,
  customClassName: null
};
var _default = StreamlineIcon;
exports.default = _default;